export default "__VITE_ASSET__b32db8eb__"